import React from 'react';
export function ProblemSection() {
  return <section id="research" className="w-full bg-white py-8 md:py-12 lg:py-16 px-4 md:px-6" style={{
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-101">
      <div className="max-w-6xl mx-auto" data-id="element-102">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start" data-id="element-103">
          {/* Image - hidden on this side, shown below heading on right */}
          <div className="order-1 lg:order-1 hidden" data-id="element-104"></div>

          {/* Content */}
          <div className="order-2 lg:order-2 lg:col-span-2" data-id="element-105">
            <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-6" style={{
            color: '#1B4F9E'
          }} data-id="element-106">
              THE PROBLEM NOBODY TALKS ABOUT
            </h2>

            <img src="https://cdn.magicpatterns.com/uploads/bmvga7xBTcRrvL6x2tnfbh/unnamed.jpg" alt="Child sleeping with phone and WiFi router emitting radiation" className="w-full rounded-lg shadow-lg object-cover mb-8" style={{
            maxHeight: '520px'
          }} data-id="element-107" />

            <div className="text-base md:text-lg leading-relaxed space-y-5" style={{
            color: '#2C3E50',
            lineHeight: '1.7'
          }} data-id="element-108">
              <p data-id="element-109">
                Sarah Mitchell, a Brisbane mother of two, couldn't remember the
                last time she'd slept through the night. Neither could her 14
                year old son, who practically lives on his phone. At 2 AM on a
                school night, he's still scrolling through TikTok his eyes
                glazed over, unable to stop, thumb endlessly swiping. She's
                tried everything: confiscating the phone, setting screen time
                limits, begging him to put it down. But the addiction is
                stronger than her rules.
              </p>

              <p data-id="element-110">
                The phone stays on his pillow. He falls asleep scrolling. He
                wakes up scrolling. In between, if he sleeps at all, it's
                shallow and interrupted.
              </p>

              <p data-id="element-111">
                In 1995, the average Australian home had zero WiFi sources.
                Today, most homes have 12+. Smart meters radiation in major
                cities are being mandated{' '}
                <strong data-id="element-112">(rolling out December 2025)</strong>. 5G towers are
                everywhere. This isn't paranoia.{' '}
                <strong data-id="element-113">This is the new reality.</strong> And nobody told us the
                radiation would be{' '}
                <strong data-id="element-114">constant, invisible, and 24/7.</strong>
              </p>
            </div>

            {/* Callout Box */}
            <div className="mt-8 p-5 rounded-r border-l-4" style={{
            backgroundColor: '#F0F7FF',
            borderColor: '#1B4F9E'
          }} data-id="element-115">
              <p className="text-base md:text-lg font-medium italic" style={{
              color: '#1B4F9E'
            }} data-id="element-116">
                In 1995, the average Australian home had zero WiFi sources.
                Today, the average household has 12. That's a complete
                transformation of our home environment in just one generation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}